<!--
 * @Description: 县
 * @Author: yangsibo
 * @Date: 2022-09-28 16:38:30
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-09-28 16:38:41
 * @FilePath: /adm.xiangli360.com/src/views/County/index.vue
-->
<template>
    <router-view />
</template>

<script>
export default {
    name: "County",
};
</script>
